function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M27.66.5H2.32a.52.52 0 00-.53.5v28a.52.52 0 00.53.52h25.36a.52.52 0 00.53-.52V1a.57.57 0 00-.55-.5zm-.52 1v5.93H2.84V1.54zM2.84 28.46V8.5h24.32v20H2.84zM16.6 4.55a.52.52 0 01.52-.55h2.57a.52.52 0 110 1h-2.57a.52.52 0 01-.52-.45zm5.22 0a.52.52 0 01.52-.55h2.57a.52.52 0 010 1h-2.57a.52.52 0 01-.52-.45zM15 10.88a7.41 7.41 0 107.41 7.41A7.41 7.41 0 0015 10.88zm0 13.76a6.37 6.37 0 116.37-6.37A6.38 6.38 0 0115 24.64zm0-11a4.68 4.68 0 104.68 4.68A4.69 4.69 0 0015 13.61zm0 8.29a3.64 3.64 0 113.63-3.63A3.64 3.64 0 0115 21.9z"
})));